/* src/app/components/Expand/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import {
  CardActions,
  Collapse,
  Divider,
  IconButton,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import styles from './styles';

class Expand extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  _onToggleExpand = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const { classes, children, text } = this.props;
    const { expanded } = this.state;
    return (
      <React.Fragment>
        <Divider />
        <CardActions>
          <Typography variant="body2" className={classes.expandText}>
            {text}
          </Typography>
          <IconButton
            className={classNames(
              classes.expand,
              { [classes.expandOpen]: expanded }
            )}
            aria-expanded={expanded}
            aria-label="Show more"
            onClick={this._onToggleExpand}
          >
            <ExpandMore />
          </IconButton>
        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          {children}
          <div style={{ height: 12 }} />
        </Collapse>
        <Divider />
      </React.Fragment>
    );
  }
}

Expand.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.any,
  text: PropTypes.string.isRequired,
};

Expand.defaultProps = {
  children: null,
};

export default withStyles(styles)(Expand);



// WEBPACK FOOTER //
// ./src/app/components/Expand/index.js